import { isEqualColors, tryParseColor } from '../color';
import { isHTMLOrSVGElement } from '../dom/node';
import {
  applyStyleToElement,
  applyStyleToRange,
  getInheritedStyleForNode,
  hasInheritedStyleForNode,
  removeStyleFromElement,
  removeStyleFromRange,
  StyleSpec,
} from '../dom/style';

const TEXT_COLOR_SPEC: StyleSpec = {
  stylePropertyName: 'color',
  initialStylePropertyValue: 'transparent',
  fontElementAttributeName: 'color',
  mapValue: keepParseableColor,
  isValueEqual: isEqualColors,
};

function keepParseableColor(value: string): string {
  const color = tryParseColor(value);
  return color ? value : '';
}

export function nodeHasTextColor(node: Node, container: Node): boolean {
  return hasInheritedStyleForNode(container, node, TEXT_COLOR_SPEC);
}

export function getTextColorForNode(node: Node, container: Node): string {
  return getInheritedStyleForNode(container, node, TEXT_COLOR_SPEC);
}

export function removeTextColorFromElement(element: Element): Node | null {
  return isHTMLOrSVGElement(element) ? removeStyleFromElement(element, TEXT_COLOR_SPEC) : element;
}

export function removeTextColorFromRange(container: Node, range: Range): Range {
  return removeStyleFromRange(container, range, TEXT_COLOR_SPEC);
}

export function applyTextColorToElement(element: HTMLElement | SVGElement, textColor: string): void {
  applyStyleToElement(element, TEXT_COLOR_SPEC, textColor);
}

export function setTextColorInRange(container: Node, range: Range, textColor: string): Range {
  return applyStyleToRange(container, range, TEXT_COLOR_SPEC, textColor);
}
